module.exports = __webpack_public_path__ + "img/arrow-prev.f9dc709e.svg";